/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Franchise_VenuesInputs */

const cs_franchise_venues = /** @type {(inputs: Franchise_VenuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pobočky`)
};

const en_franchise_venues = /** @type {(inputs: Franchise_VenuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branches`)
};

/**
* | output |
* | --- |
* | "Branches" |
*
* @param {Franchise_VenuesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const franchise_venues = /** @type {((inputs?: Franchise_VenuesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchise_VenuesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_franchise_venues(inputs)
	return cs_franchise_venues(inputs)
});